<template>
  <div class="has-background-white-bis fixspace">

    <section class="hero is-medium has-background-white-ter is-bold is-hidden-mobile">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-uppercase" style="font-weight: 900;">
            {{ $t('general.topics') }}
          </h1>
          <h2 class="subtitle py-5 has-text-grey-light">
            TOPICS
          </h2>
        </div>
      </div>
    </section>

    <section class="section py-5 has-background-white-ter is-bold is-hidden-tablet">
      <div class="container">
        <h1 class="title is-4 is-uppercase" style="font-weight: 900;">
          {{ $t('general.topics') }}
        </h1>
      </div>
    </section>

    <section class="section">

      <div class="container is-max-desktop" v-if="loading">
        <div class="columns is-multiline is-variable is-mobile is-gapless">
          <div class="column is-4-desktop is-4-tablet is-half-mobile"
            v-for="i in media" :key="i">
            <div class="card" style="border: 1px solid #dedede;">
              <div class="card-image">
                <figure class="image is-1by1 skeleton">
                  <div class="skeleton-block"></div>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container is-max-desktop" v-if="!loading">
        <div class="columns topics-group is-multiline is-variable is-mobile is-gapless">
          <div class="column is-4-desktop is-4-tablet is-half-mobile"
            v-for="(item, index) in topics" :key="index">
            <router-link :to="'/topics/' + item.id">
              <div class="card" style="border: 1px solid #dedede;">
                <div class="card-image">
                  <b-image
                    :src="item.description.image"
                    :src-fallback="require('@/assets/no-genre.jpg')"
                    :alt="item.name"
                    ratio="is-1by1"
                  >
                    <!-- <b-skeleton
                      :rounded="false"
                      class="skeleton-placeholder"
                      slot="placeholder"
                      height="100%"
                    ></b-skeleton> -->
                  </b-image>
                </div>
                <div class="card-content is-overlay
                is-flex is-justify-content-flex-start is-align-items-flex-end"
                style="background-color: rgba(0,0,0,0.45);">
                  <span class="has-text-white has-text-weight-semibold
                    is-size-5-desktop is-size-6-mobile">
                    {{ item.name }}
                  </span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

    </section>

  </div>
</template>

<script>
import { getScenarios } from '@/api/api';

export default {
  name: 'Topics',

  metaInfo() {
    return {
      title: this.$t('title.topics'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.topics') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      loading: true,
      media: 12,
      topics: [],
    };
  },

  computed: {

  },

  created() {
    this.$firebase.firestore().collection('settings')
      .doc('home')
      .get()
      .then((snapshot) => {
        const document = snapshot.data();

        getScenarios({
          params: { ids: document.featuredScenarios.join(',') },
          headers: { locale: this.$i18n.locale },
        })
          .then((result) => {
            this.topics = result.data.data;
            this.loading = false;
          }).catch((err) => { console.error(err); });
      });
  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    getTopicsData(dataObject) {
      getScenarios({
        params: { ids: dataObject.featuredScenarios.join(',') },
        headers: { locale: this.$i18n.locale },
      })
        .then((result) => {
          this.topics = result.data.data;
          this.loading = false;
        }).catch((err) => { console.error(err); });
    },

    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.topics'));
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.topics-group {

  &:hover .column:not(:hover) {
    filter: grayscale(100%);
    transition: .3s;

    &::after {
      background-color: rgba(#000, 0.5);
    }
  }
}
</style>
